import { Site } from "./Site";

export class Production {
    siteId: number;
    temporaryFlag: boolean;
    proposedFlag : boolean;
    comment: string;
    realPlantFlag: boolean;
    linflag: boolean;
    loxflag: boolean;
    larflag: boolean;
    larTpd: number;
    argonPurifierFlag: boolean;
    liquifierTypeId: string;
    lhyflag: boolean;
    lhyvolumeTpd: number;
    bhyflag: boolean;
    bhyKnm3h: number;
    lheFlag: boolean;
    co2flag: boolean;
    gcO2Flag: boolean;
    apexFlag: boolean;
    tgLinflag: boolean;
    tgLoxflag: boolean;
    ganflag: boolean;
    goxflag: boolean;
    genGasSogflag: boolean;
    forElectronics: number;
    co2volumeTpd: number;
    gcO2VolumeTPD: number;
    sourceOfGas: string;
    sourceOfGasGCO2: string;
    hostSupplier: string;
    hostCustomer: string;
    sapplantId: string;
    physicallyThereFlag: boolean;
    dismantledFlag: boolean;
    shutDownFlag: boolean;
    onstreamDate: Date;
    shutdownDate: Date;
    nsf60certifiedFlag: boolean;
    capacity: number;
    capacityUOM: string;
    laR_TPDUOM: string;
    lhyVolumeTPDUOM: string;
    bHy_knm3hUOM: string;
    cO2VolumeTPDUOM: string;
    gcO2VolumeTPDUOM: string;
    insertedDate: string;
    insertedBy: string;
    modifiedDate: string;
    modifiedBy: string;
    site: Site;
    activeFlag: boolean;
    plantStatus: string;
    luX_Flag : boolean;
    luX_TPD : number;
    geoCalculation: boolean;
    constructor() {
        this.capacity = 0;
        this.larTpd = 0;
        this.lhyvolumeTpd = 0;
        this.bhyKnm3h = 0;
        this.gcO2VolumeTPD = 0;
        this.co2volumeTpd = 0;
        this.luX_TPD = 0;
        this.loxflag = false;
        this.linflag = false;
        this.larflag = false;
        this.lhyflag = false;
        this.lheFlag = false;
        this.bhyflag = false;
        this.co2flag = false;
        this.gcO2Flag = false;
        this.apexFlag = false;
        this.luX_Flag = false;
        this.argonPurifierFlag = false;
        this.physicallyThereFlag = false;
        this.shutDownFlag = false;
        this.dismantledFlag = false;
        this.nsf60certifiedFlag = false;
        this.activeFlag = true;
        this.liquifierTypeId = "U";
        this.geoCalculation = false;
    }
}